import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Landmark, Tv } from 'lucide-react';
const experiences = [{
  title: 'Manager - Content',
  organization: "Chief Minister's Media Cell, Uttar Pradesh",
  duration: '7 Years',
  icon: Landmark,
  description: "Leading content strategy, narrative building, and media communications at the highest level of state government. Orchestrating comprehensive communication strategies for the Chief Minister's office, ensuring accurate and impactful dissemination of government policies and achievements."
}, {
  title: 'Electronic Media Professional',
  organization: 'Various Leading Networks',
  duration: '21 Years',
  icon: Tv,
  description: 'Extensive background in broadcast journalism, news production, and editorial leadership. Directed high-stakes coverage, managed editorial teams, and shaped public discourse through impactful electronic media campaigns.'
}, {
  title: 'Sr. Research Fellow',
  organization: 'Ministry of Culture, Govt of India',
  duration: 'Research Tenure',
  icon: Briefcase,
  description: 'Conducted advanced research contributing to national cultural narratives and policy understanding. Bridged the gap between cultural heritage and modern communication strategies.'
}];
export function Experience() {
  return <section id="experience" className="py-28 px-4 sm:px-6 lg:px-8 relative" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20 text-center" data-id="element-90">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-zinc-100" data-id="element-91">
            Career Trajectory
          </h2>
          <p className="text-lg text-zinc-400 font-light tracking-wide uppercase" data-id="element-92">
            Decades of dedicated service in media and governance
          </p>
        </motion.div>

        <div className="relative ml-4 md:ml-12" data-id="element-93">
          {/* Gold gradient timeline line */}
          <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gradient-to-b from-amber-500/80 via-amber-500/30 to-transparent" data-id="element-94"></div>

          {experiences.map((exp, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="mb-16 ml-10 md:ml-16 relative group" data-id="element-95">
              {/* Pulsing gold dot */}
              <span className="absolute -left-[41px] md:-left-[65px] flex items-center justify-center w-12 h-12 rounded-full bg-zinc-950 border-2 border-amber-500/50 shadow-[0_0_15px_rgba(245,158,11,0.3)] group-hover:shadow-[0_0_25px_rgba(245,158,11,0.6)] transition-shadow duration-500 z-10" data-id="element-96">
                <exp.icon className="w-5 h-5 text-amber-500" data-id="element-97" />
                <span className="absolute inset-0 rounded-full border border-amber-500/30 animate-ping opacity-20" data-id="element-98"></span>
              </span>

              <div className="bg-zinc-900/40 backdrop-blur-sm border border-zinc-800/80 rounded-2xl p-8 hover:bg-zinc-900/60 hover:border-amber-500/30 transition-all duration-500 shadow-xl" data-id="element-99">
                <div className="flex flex-col md:flex-row md:items-start justify-between mb-4 gap-4" data-id="element-100">
                  <div data-id="element-101">
                    <h3 className="text-2xl font-serif font-bold text-zinc-100 mb-1" data-id="element-102">
                      {exp.title}
                    </h3>
                    <h4 className="text-lg text-amber-500/90 font-serif italic" data-id="element-103">
                      {exp.organization}
                    </h4>
                  </div>
                  <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-amber-500/10 text-amber-400 border border-amber-500/20 whitespace-nowrap" data-id="element-104">
                    {exp.duration}
                  </span>
                </div>
                <p className="text-zinc-400 leading-relaxed text-lg" data-id="element-105">
                  {exp.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}